import { atom, useAtom } from "jotai";

export const comparativeAnalysisFormDropdownOpenAtom = atom(false);

export const useComparativeAnalysisFormDropdownOpen = () =>
  useAtom(comparativeAnalysisFormDropdownOpenAtom);
